import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AuthShell from "@/components/AuthShell";
import { api, errMsg } from "@/lib/api";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthShell title="Pemulihan kata sandi" subtitle="Masukkan email akun Anda untuk menerima tautan atur ulang kata sandi.">
      <form onSubmit={submit} className="space-y-5" data-testid="forgot-password-form">
        <div className="space-y-2"><Label>Email</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" /></div>
        {msg && <p className="text-sm rounded bg-emerald-50 text-emerald-700 p-3" data-testid="forgot-success-message">{msg} Cek inbox (dan folder spam). Jika belum menerima email dalam beberapa menit, hubungi admin.</p>}
        <Button type="submit" disabled={busy} className="w-full bg-slate-900 h-11" data-testid="forgot-submit-button">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Kirim Tautan</Button>
        <p className="text-center text-sm"><Link to="/login" className="hover:underline" data-testid="forgot-back-login-link">Kembali ke halaman masuk</Link></p>
      </form>
    </AuthShell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [pw, setPw] = useState({ a: "", b: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.a !== pw.b) return toast.error("Konfirmasi kata sandi tidak cocok");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password: pw.a });
      toast.success("Kata sandi berhasil diubah. Silakan masuk.");
      nav("/login");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthShell title="Atur ulang kata sandi" subtitle="Buat kata sandi baru minimal 6 karakter.">
      <form onSubmit={submit} className="space-y-5" data-testid="reset-password-form">
        <div className="space-y-2"><Label>Kata sandi baru</Label><Input type="password" required value={pw.a} onChange={(e) => setPw({ ...pw, a: e.target.value })} data-testid="reset-password-input" /></div>
        <div className="space-y-2"><Label>Ulangi kata sandi</Label><Input type="password" required value={pw.b} onChange={(e) => setPw({ ...pw, b: e.target.value })} data-testid="reset-password-confirm-input" /></div>
        <Button type="submit" disabled={busy} className="w-full bg-slate-900 h-11" data-testid="reset-submit-button">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Simpan Kata Sandi</Button>
      </form>
    </AuthShell>
  );
}
